<main>
  <ul>
    <li class="title">
      <i
        class="icon-small-back pull-left"
        routerLink="../options"></i>
      {{ "number.number" | Translate }}
    </li>
  </ul>
  <div
    id="content"
    class="list">
    <div
      *ngIf="!usersError"
      class="group-title number">
      {{ "number.question" | Translate }}
    </div>

    <ul *ngIf="usersLoading">
      <li
        *ngFor="let idx of [1, 2, 3, 4, 5]"
        class="number">
        <ngx-skeleton-loader [theme]="{ 'width.%': 100, 'height.px': 30, 'margin-bottom.px': 0 }"></ngx-skeleton-loader>
      </li>
    </ul>

    <div
      *ngIf="!usersLoading && usersError"
      class="vox-inline-message vox-inline-message_gold">
      <div>
        <i class="icon-small-alert-triangle"></i>
        <span>
          {{ "number.failed-to-load-message" | Translate }}
          <a (click)="loadUsers()">{{ "number.retry" | Translate }}</a>
        </span>
      </div>
    </div>

    <ul *ngIf="!usersLoading && !usersError">
      <li
        *ngFor="let did of dids"
        (click)="setOutboundDid(did)"
        class="number"
        [ngClass]="{ active: did.id === outboundDid.didId }">
        <span>{{ did.label }}</span>
        <br />
        <span>{{ did.number }}</span>
        <p
          *ngIf="did.temporary"
          class="temporary-number-label">
          {{ "number.temporary-number-message" | Translate }}
        </p>
        <i
          *ngIf="did.loading"
          class="loader pull-right"
          [ladda]="true"
          data-spinner-color="black"
          data-spinner-size="25"
          data-style="slide-left"></i>
        <i
          *ngIf="!did.loading && did.error"
          class="icon-small-alert-triangle pull-right"
          container="body"
          ngbTooltip="{{ 'number.failed-outbound-message' | Translate }}"></i>
        <i
          *ngIf="!did.loading && !did.error"
          class="pull-right"
          [ngClass]="did.temporary ? 'icon-small-alert' : 'icon-small-check'"></i>
      </li>
    </ul>
  </div>
</main>
